import SubmissionError from '../../../error/SubmissionError'
import http from '../../../utils/http'
import security from '../../../utils/security'
import {
  INVOICE_CORRECTION_RESET,
  INVOICE_CORRECTION_RETRIEVE_ERROR,
  INVOICE_CORRECTION_RETRIEVE_LOADING,
  INVOICE_CORRECTION_RETRIEVE_SUCCESS
} from './mutation-types'

const state = {
  retrieveError: '',
  retrieveLoading: false,
  retrieved: null
}

function retrieveError(retrieveError) {
  return {type: INVOICE_CORRECTION_RETRIEVE_ERROR, retrieveError};
}

function retrieveLoading(retrieveLoading) {
  return {type: INVOICE_CORRECTION_RETRIEVE_LOADING, retrieveLoading};
}

function retrieveSuccess(retrieved) {
  return {type: INVOICE_CORRECTION_RETRIEVE_SUCCESS, retrieved};
}

function reset () {
  return {type: INVOICE_CORRECTION_RESET}
}

const getters = {
  retrieveError: state => state.retrieveError,
  retrieveLoading: state => state.retrieveLoading,
  retrieved: state => state.retrieved
}

const actions = {
  retrieve({ commit }, id) {
    commit(retrieveLoading(true));
    commit(retrieveError(null));
   return http.fetch('/invoices/' + id)
      .then(response => response.json())
      .then(data => {
        const ivoiceData =
        {
          '@id' : data['@id'],
          id: data.id,
          fullNumber: data.fullNumber,
          customer: data.customer,
          customerData: {
            name: data.customerData.name,
            nip: data.customerData.nip,
            regon: data.customerData.regon,
            customerAddress: {
              city: data.customerData.customerAddress.city,
              number: data.customerData.customerAddress.number,
              postalCode: data.customerData.customerAddress.postalCode,
              street: data.customerData.customerAddress.street,
              country: data.customerData.customerAddress.country
            }
          },
          items: data.items,
          paymentDate: data.paymentDate,
          endDate: data.endDate,
          createDate: data.createDate,
          comments: data.comments,
          currency: data.currency['@id'],
          paymentType: data.paymentType['@id'],
          amount: data.amount,
        }
        commit(retrieveLoading(false));
        commit(retrieveSuccess(ivoiceData));
      })
      .catch(e => {
        commit(retrieveLoading(false));
        if(security.handleAuthorizationError(e)){
          return;
        }
        commit(retrieveError(e.message));
      });
  },
  reset ({commit}) {
    commit(reset())
  }
}

const mutations = {
  [INVOICE_CORRECTION_RETRIEVE_LOADING] (state, payload) {
    state.retrieveLoading = payload.retrieveLoading
  },
  [INVOICE_CORRECTION_RETRIEVE_ERROR] (state, payload) {
    state.retrieveError = payload.retrieveError
  },
  [INVOICE_CORRECTION_RETRIEVE_SUCCESS](state, payload) {
    state.retrieved = payload.retrieved;
  },
  [INVOICE_CORRECTION_RESET] (state) {
    state.retrieveError = ''
    state.retrieveLoading = false
    state.retrieved = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/invoice/correction.js